import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {MatSnackBar} from '@angular/material';

import {FeedbackService} from '../../../../services/feedback.service';
import {LogService} from '../../../../services/log.service';


@Component({
	selector: 'feedback',
	templateUrl: './feedback.component.html',
	styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
	constructor(
		public snackBar: MatSnackBar,

		private feedbackService: FeedbackService,
		private log: LogService
	) {}


	feedback = false;
	feedbackComments = '';

	@Output()
	feedbackSent = new EventEmitter();


	ngOnInit() {
	}


	sendFeedback() {
		this.feedbackSent.next();

		// console.log('sendFeedback clicked!!');
		// console.log('feedbackComments:');
		// console.log(this.feedbackComments);
		this.feedback = false;

		this.feedbackService.sendFeedback(this.feedbackComments)
		.then(() => {
			this.feedbackComments = '';
			this.log.info('Feedback saved to db!');
			this.snackBar.open('Feedback Sent.  Thank You!', 'X', {duration: 2000});
		})
		.catch((err: any) => {
			this.feedbackComments = '';
			// TODO - add toast
			// console.log('toast: server not available');
			this.log.error(err);
		});
	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/feedback/feedback.component.ts